import { z } from "zod";

/**
 * Search-param schema for the `/fulfillment` route.
 *
 * `id` opens that row's shipment drawer. It is `shipmentRowId(row)` — the
 * shipment id, or the order / membership id for an order that has not shipped
 * — so it is named `id`, not `shipment`. Coerced and `.catch`-guarded like
 * `usersSearchSchema`: TanStack JSON-parses raw search values, and a thrown
 * ZodError takes down the router's loader pipeline.
 */
export const fulfillmentSearchSchema = z.object({
  id: z.coerce.string().optional().catch(undefined),
});

export type FulfillmentRouteSearch = z.infer<typeof fulfillmentSearchSchema>;
